import axios from 'axios';
const API_URL = process.env.API_URL;

export default function setup(router) {
	axios.interceptors.request.use(function(config) {
		const token = localStorage.token;
		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}
		config.headers['Content-Type'] = 'application/json';
		config.headers['X-Requested-With'] =  'XMLHttpRequest';
		config.baseURL = API_URL;
		return config;
	}, function(err) {
		return Promise.reject(err);
	});
	axios.interceptors.response.use(function(config) {
		if (config.data.logout) {
			//alert('You have been logged out');
			localStorage.returnURL = window.location.pathname;
			router.push('/logout?msg=toolong');
			return false;
		}
		if (config.data.version) {
			if (version != config.data.version) {
				//different version of front-end and back-end...reload
				window.location.reload(true);
				return false;
			}
		}
		return config;
	}, function(err) {
		return Promise.reject(err);
	});
}